module.exports = __webpack_public_path__ + "img/back-ios.6e4f9ba4.svg";